import Miusics from "./Miusics/Miusics"
import './Body.css'



const Body=({ID ,MiusicsIMG , MiusicsTitle , MiusicsDescribtion ,MiusicAdress})=>{
    return(
        <div>
            <div className="BodyMiusic">
                <div className="MiusicsBodyDiv"><Miusics ID={ID} MiusicsIMG={MiusicsIMG} MiusicsTitle={MiusicsTitle} MiusicsDescribtion={MiusicsDescribtion} MiusicAdress={MiusicAdress}/></div>    
            </div>
            <div>
                
            </div>
        </div>
        
    )
}


export default Body